import { render, staticRenderFns } from "./fenxiao_order_detail.vue?vue&type=template&id=f5aeced0&scoped=true"
import script from "./fenxiao_order_detail.vue?vue&type=script&lang=js"
export * from "./fenxiao_order_detail.vue?vue&type=script&lang=js"
import style0 from "./fenxiao_order_detail.vue?vue&type=style&index=0&id=f5aeced0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aeced0",
  null
  
)

export default component.exports